import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import Select, { IOption } from '../../../../components/Select/Select';
import {
  addParticipants,
  addParticipantsFn,
  createOrUpdateBatchPDPProgram,
  createOrUpdateBatchPDPProgramFn,
  createOrUpdateClass,
  createOrUpdateClassFn,
  createOrUpdatePDPProgram,
  createOrUpdatePDPProgramFn,
  createOrUpdateTopic,
  createOrUpdateTopicFn,
  deletePDPProgram,
  deletePDPProgramFn,
  getAllTopics,
  getAllTopicsFn,
  getMyManagingPDPInTerm,
  getMyManagingPDPInTermFn,
  getMyManagingTerms,
  getMyManagingTermsFn,
  getMyPDPInTerm,
  getMyPDPInTermFn,
  getMyTerms,
  getMyTermsFn,
  queryClasses,
  queryClassesFn,
} from 'store/pdp/pdpSlice';
import ButtonGroup from 'components/ButtonGroup';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { navigate, RouteComponentProps } from '@reach/router';
import cloneDeep from 'lodash/cloneDeep';
import Badge from '../../../../components/Badge/Badge';
import Button from '../../../../components/Button/Button';
import ExportExcell from '../PDPClass/ExportExcell';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../../../components/CKEditorField/CKEditorField';
import Collapsible from '../../../../components/Collapsible/Collapsible';
import HoverIcon from '../../../../components/HoverIcon/HoverIcon';
import Icon from '../../../../components/Icon/Icon';
import Input from '../../../../components/Input/Input';
import LoadingCircleIndicator from '../../../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import Modal from '../../../../components/Modal';
import notify from '../../../../components/Notify';
import { notifyError } from '../../../../components/Notify/Notify';
import { smartDateDuration, smartDateString } from '../../../../utils/date';
import {
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from '../../../../utils/number';
import {
  black,
  blue,
  gray,
  green,
  lightGray,
  lightGreenSolid,
  lightRed,
  lightRedSolid,
  lightYellowSolid,
  orange,
  red,
  white,
  yellow,
} from '../../../../utils/style/colors';
import { Card } from '../CompanyPermissionSchemes/styles';
import { messages } from './Messages';
import { AddModal, PDPPersonEditor } from './PDPPersonEditor';
import {
  ApproveGroup,
  ApproveGroupItem,
  Container,
  HContainer,
  Header,
  PersonContainer,
  PersonInList,
  PhaseInfo,
  TagListContainer,
  TermsWrapper,
} from './style';
import { removeDuplicates } from '../../../../utils/happyFunctions';
import APopover from '../../../../components/APopover';
import {
  ApprovedStateByUser,
  ApproveState,
  CompanyPDPState,
  PDPClass,
  PDPProgram,
  PersonalTermTopic,
  Phase,
  Term,
  TermPersonProposedProgramProperties,
  Topic,
} from '../../../../store/pdp/types';
import { TopicEditor } from '../PDPTopics/TopicEditor';
import SelectWithPopover from '../../../../components/Select/SelectWithPopover';
import {
  HintIcon,
  HintText,
  QuestionHintBox,
} from '../../../../components/FileManager/ItemsViewer/Survey/SurveyEditor/GeneralQuestion/styles';
import { FixedSizeList as List, ListChildComponentProps } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { ITags, ITagView } from '../../../../store/providers/providerTypes';
import {
  ICompany,
  ICompanyMember,
  ICompanyRole,
} from '../../../../store/companies/companiesTypes';
import {
  appDispatch,
  IThisUser,
  IUsers,
  RootState,
} from '../../../../store/store';
import { isCompanyOwnerOrSupport } from '../../../../store/companies/companiesUtils';
import Dropdown from '../../../../components/Dropdown';
import { withTitle } from '../../../../components/withTitle';

const statColor = {
  approved: green,
  rejected: red,
  unknown: gray,
  previousRejected: lightRed,
};
interface StateToProps {
  pdpState: CompanyPDPState;
  tags: ITags['data'];
  company: ICompany;
  term?: Term;
  users: IUsers['map'];
  thisUser: IThisUser;
  isPDPAdmin: boolean;
}
interface DispatchToProps {
  getMyTerms: (pdpId: number) => ReturnType<typeof getMyTermsFn>;
  getMyManagingTerms: (
    pdpId: number
  ) => ReturnType<typeof getMyManagingTermsFn>;
  getAllTopics: (pdpId: number) => ReturnType<typeof getAllTopicsFn>;
  addNewTopic: (topic: Topic) => ReturnType<typeof createOrUpdateTopicFn>;
  getMyPDPProgram: (
    termId: number,
    pdpId: number
  ) => ReturnType<typeof getMyPDPInTermFn>;
  getMyManagingPDPProgram: (
    termId: number,
    pdpId: number
  ) => ReturnType<typeof getMyManagingPDPInTermFn>;
  createOrUpdatePDPProgram: (
    program: PDPProgram,
    pdpId: number
  ) => ReturnType<typeof createOrUpdatePDPProgramFn>;
  deletePDPProgram: (
    program: PDPProgram,
    pdpId: number
  ) => ReturnType<typeof deletePDPProgramFn>;
  createOrUpdateBatchPDPProgram: (
    program: PDPProgram[],
    pdpId: number
  ) => ReturnType<typeof createOrUpdateBatchPDPProgramFn>;
  queryClasses: (
    pdpId: number,
    startDate?: number,
    endDate?: number,
    isTemplate?: boolean
  ) => ReturnType<typeof queryClassesFn>;
  createOrUpdateClass: (
    clazz: PDPClass,
    pdpId: number
  ) => ReturnType<typeof createOrUpdateClassFn>;
  addParticipantsToClass: (
    pdpId: number,
    clazzId: number,
    userIds: number[]
  ) => ReturnType<typeof addParticipantsFn>;
}
interface IOwnProps {
  companyId?: number;
  termId?: string;
  pdpId?: string | number;
}

function hasAll(item: number[], values: number[]) {
  return values.every((i) => item.includes(i));
}

export interface PDPProblems {
  message: string;
  level: 'warning' | 'error';
  relatedTagId: number;
  topics?: number[];
  toAddTopics?: number[];
  currentCount?: number;
}
const sortPersonsOptions: IOption[] = [
  { value: 'alphabetic', label: messages.alphabetic },
  { value: 'creationDate', label: messages.creationDate },
  { value: 'updateDate', label: messages.updateDate },
];

export const getPDPProblems = (
  program: PDPProgram,
  term: Term,
  pdpState: CompanyPDPState,
  company: ICompany,
  tags: ITags['data']
): PDPProblems[] => {
  const ret: PDPProblems[] = [];
  const missingTopic: { [key: number]: number[] } = {};
  const topicCount = { '-1': 0 };
  const userRoles = new Set<number>(
    Object.keys(company.members[program.memberUserId]?.roles || {}).map((it) =>
      Number(it)
    )
  );
  const missingMandatorTopicIds = [] as number[];
  Object.values(pdpState.topics || {}).forEach((topic) => {
    if (topic.status !== 'Exists' && topic.status !== 'Proposed') return;
    const relatedToUser =
      topic.properties.relatedToRoles.length === 0 ||
      topic.properties.relatedToRoles.some((it) => userRoles.has(it));
    const mandatoryForUser = topic.properties.mandatoryForRoles.some((it) =>
      userRoles.has(it)
    );
    const included = program.properties.topics.find(
      (it) =>
        it.topicId === topic.id &&
        it.approvedStateByUsers[it.approvedStateByUsers.length - 1]
          ?.approved === 'Approved'
    );
    if (!relatedToUser && included)
      ret.push({
        message: messages.topicIsNotRelatedToUser,
        level: 'warning',
        topics: [topic.id!],
        relatedTagId: -2,
      });
    if (mandatoryForUser && !included) {
      missingMandatorTopicIds.push(topic.id!);
    }
    topic.properties.tags.forEach((tagId) => {
      if (included) {
        if (!topicCount[tagId]) topicCount[tagId] = 0;
        topicCount[tagId]++;
      } else if (relatedToUser) {
        if (!missingTopic[tagId]) missingTopic[tagId] = [];
        missingTopic[tagId].push(topic.id!);
      }
    });
    if (included) topicCount['-1']++;
  });

  if (missingMandatorTopicIds.length > 0) {
    ret.push({
      message: messages.missingRequiredTopic,
      level: 'error',
      toAddTopics: missingMandatorTopicIds,
      relatedTagId: -3,
    });
  }
  Object.entries(term.properties.perTagLimits).forEach(([tagId, limit]) => {
    if (tagId === '-1') {
      if (limit.min && (topicCount['-1'] || 0) < limit.min)
        ret.push({
          message: messages.pleaseSelectAtLeast(limit.min),
          level: 'error',
          relatedTagId: -1,
          currentCount: topicCount['-1'] || 0,
        });
      else if (limit.max && (topicCount['-1'] || 0) > limit.max) {
        ret.push({
          message: messages.pleaseSelectAtMost(limit.max),
          level: 'error',
          relatedTagId: -1,
          currentCount: topicCount['-1'] || 0,
        });
      }
      return;
    }
    if (limit.min === -1 && (missingTopic[Number(tagId)]?.length || 0) > 0) {
      ret.push({
        message: messages.missingRequiredTopic,
        level: 'error',
        toAddTopics: missingTopic[Number(tagId)],
        relatedTagId: Number(tagId),
      });
      return;
    }
    const parentId = tags[Number(tagId)]?.parentId;
    if ((limit.min || 0) > (topicCount[tagId] || 0)) {
      ret.push({
        message: messages.fewTopicOfTypeSelected(
          tags[parentId || 0]?.text || '',
          tags[tagId]?.text || '',
          limit.min!
        ),
        level: 'error',
        relatedTagId: Number(tagId),
        currentCount: topicCount[tagId] || 0,
      });
    }
    if ((limit.max || 10000) < (topicCount[tagId] || 0)) {
      ret.push({
        message: messages.extraTopicOfTypeSelected(
          tags[parentId || 0]?.text || '',
          tags[tagId]?.text || '',
          limit.min!
        ),
        level: 'error',
        relatedTagId: Number(tagId),
        currentCount: topicCount[tagId] || 0,
      });
    }
  });
  return ret;
};

const sortOptions = [
  { value: 'alphabetic', label: messages.alphabetic },
  { value: 'approvedCount', label: messages.approvedCount },
  { value: 'requestCount', label: messages.requestCount },
  { value: 'suggestCount', label: messages.suggestCount },
  { value: 'waitingCount', label: messages.waitingCount },
] as IOption[];
type ComponentProps = StateToProps &
  DispatchToProps &
  IOwnProps &
  RouteComponentProps;

interface RoleStats {
  [key: number]: {
    allUsers: number[];
    approvedUsers: number[];
    rejectedUsers: number[];
    unknownUsers: number[];
  };
}

interface TopicStats {
  approved: number[];
  rejected: number[];
  unknown: number[];
  previousRejected: number[];
  mandatoryUsers: number[];
  mandatoryApprovedUserCount: number;
  optionalUsers: number[];
  optionalApprovedUserCount: number;
  notRelatedUsers: number[];
  notRelatedApprovedUserCount: number;
  mandatoryRoleStats: RoleStats;
  optionalRoleStats: RoleStats;
  [key: number]: number;
}
function newTopicStats() {
  return {
    approved: [],
    rejected: [],
    unknown: [],
    previousRejected: [],
    mandatoryUsers: [],
    mandatoryApprovedUserCount: 0,
    optionalUsers: [],
    optionalApprovedUserCount: 0,
    notRelatedUsers: [],
    notRelatedApprovedUserCount: 0,
    mandatoryRoleStats: {} as RoleStats,
    optionalRoleStats: {} as RoleStats,
  } as TopicStats;
}

const PDPPersonManager: React.FC<ComponentProps> = (props) => {
  const pdpId = Number(props.pdpId);
  const selectedPdpCompany = props.company.pdpPanels.find(
    (el) => el.id === pdpId
  )!;

  const [loading, setLoading] = useState(false);
  const [addingBatch, setAddingBatch] = useState(new Set<string>());
  const [filterName, setFilterName] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState(
    null as number | null
  );

  const [creatingClass, setCreatingClass] = useState([] as number[]);
  const [selectedPost, setSelectedPost] = useState(null as number | null);
  const [dataLoadFailed, setDataLoadFailed] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null as number | null);
  const [dirty, setDirty] = useState(false);
  const [selectedBatchAddRoleOption, setSelectedBatchAddRoleOption] = useState(
    [] as IOption[]
  );
  const [personSort, setPersonSort] = useState('updateDate');
  const [sortTopics, setSortTopics] = useState(
    'requestCount' as
      | 'alphabetic'
      | 'approvedCount'
      | 'suggestCount'
      | 'requestCount'
      | 'waitingCount'
  );
  const [selectedTopicToView, setSelectedTopicToView] = useState(
    undefined as number | undefined
  );
  const [selectedBatchAddTopic, setSelectedBatchAddTopic] = useState(
    null as number | null
  );
  const [selectedBatchAddTopicTags, setSelectedBatchAddTopicTags] = useState(
    [] as number[]
  );
  const [searchedTopicState, setSearchedTopicState] = useState<string>('');
  const [selectedBatchChangeTopicTags, setSelectedBatchChangeTopicTags] =
    useState({} as { [topicId: number]: { [tagId: number]: number } });
  const setSelectedBatchAddTopicTag = (
    titleTagId: number,
    valueTagId: number
  ) => {
    const ret = [
      valueTagId,
      ...selectedBatchAddTopicTags.filter(
        (it) => props.tags[it].parentId !== titleTagId
      ),
    ];
    setSelectedBatchAddTopicTags(ret);
  };
  const [selectedTab, setSelectedTab] = useState(
    'persons' as 'persons' | 'topics'
  );
  useEffect(() => {
    setSelectedBatchAddTopicTags([]);
  }, [selectedBatchAddTopic]);
  useEffect(() => {
    setLoading(true);
    const requests = [] as Promise<any>[];
    if (!props.term || Object.keys(props.term).length === 0) {
      requests.push(props.getMyTerms(pdpId!));
      requests.push(props.getMyManagingTerms(pdpId));
    }
    if (props.term && Object.keys(props.term).length > 0) {
      requests.push(
        props.getMyPDPProgram(props.term.id!, pdpId).catch(() => {
          return Promise.resolve();
        })
      );
      requests.push(props.getMyManagingPDPProgram(props.term.id!, pdpId));
    }
    if (!props.pdpState.allTopicsLoaded && pdpId)
      requests.push(props.getAllTopics(pdpId));
    if (props.isPDPAdmin && pdpId) {
      // requests.push(
      props.queryClasses(
        pdpId,
        props.term?.startDate || undefined,
        props.term?.endDate || undefined,
        false
      );
      // );
      // requests.push(
      //   props.queryClasses(
      //     props.company.pdpPanel.id,
      //     undefined,
      //     undefined,
      //     true
      //   )
      // );
    }
    setLoading(true);
    Promise.allSettled(requests)
      .finally(() => setLoading(false))
      .catch(() => {
        setLoading(false);
        setDataLoadFailed(true);
      });
  }, [props.term]);

  const [tagGroup, setTagGroup] = useState({} as { [key: number]: number[] });
  const now = new Date().getTime();
  const phase = props.term?.properties?.phaseConfig?.phases?.find((it) => {
    return it.startDate! < now && it.endDate! > now;
  });
  let shadowPhase: Phase | undefined;
  if (!phase && props.isPDPAdmin) {
    shadowPhase = [...(props.term?.properties?.phaseConfig?.phases || [])]
      .sort((a, b) => b.startDate! - a.startDate!)
      .find((it) => {
        return it.endDate! < now;
      });
    if (!shadowPhase) {
      shadowPhase = [
        ...(props.term?.properties?.phaseConfig?.phases || []),
      ].sort((a, b) => a.startDate! - b.startDate!)[0];
    }
  }
  const hintKey = 'hideHint' + phase?.id + '_' + props.term?.id;
  const [hintOpen, setHintOpen] = useState(false);

  useEffect(() => {
    setHintOpen(
      !!phase?.phaseHint?.length && localStorage.getItem(hintKey) !== 'true'
    );
  }, [phase]);

  // useEffect(() => {
  //   setSelectedTab(phase ? 'Editable' : 'Visible');
  // }, [phase]);

  useEffect(() => {
    const ret = Object.values(props.tags).reduce((current, item: ITagView) => {
      if (item.parentId) {
        if (!current[item.parentId]) current[item.parentId] = [];
        current[item.parentId].push(item.id);
      }
      return current;
    }, {});
    setTagGroup(ret);
  }, [props.tags]);

  const [requestingTopic, setRequestingTopic] = useState(false);
  const [newTopicName, setNewTopicName] = useState('');
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [requestingNewTopicModalOpen, setRequestingNewTopicModalOpen] =
    useState(false);
  if (!phase && !shadowPhase && props.isPDPAdmin) {
    return <div>{messages.pleaseSpecifyPhases}</div>;
  }
  if (loading)
    return (
      <div>
        <LoadingCircleIndicator />
      </div>
    );

  if (!props.term) {
    return <div>{messages.termNotFound}</div>;
  }
  if (dataLoadFailed) {
    return <div>{messages.errorLoadingData}</div>;
  }
  const thisUserId = Number(props.thisUser.userId);

  const allCurrentRoleIds = new Set<number>();
  const personPrograms =
    props.pdpState.terms?.[Number(props.termId)]?.personPrograms || {};
  const targetUserIds: number[] = [];
  const onlySelf = phase?.whoManagesWhom?.length === 0;
  const currentUserRoles = new Set(
    Object.keys(props.company.members[props.thisUser.userId!].roles).map((it) =>
      Number(it)
    )
  );

  const targetRolesToManage = [] as number[][];
  phase?.whoManagesWhom?.find((it) => {
    if (currentUserRoles.has(it.managerRoleId)) {
      if (!it.respectDistrict) {
        it.targetRolesId.forEach((t) => {
          targetRolesToManage.push([t]);
        });
        return;
      }
      const childIds = Object.keys(
        props.company.members[thisUserId].roles
      ).filter((roleId) => {
        return !!(
          props.company.roles[roleId].surroundingMeRoles?.includes(
            it.managerRoleId
          ) && props.company.roles[roleId].roleType === 'Compound'
        );
      });
      const districts = childIds
        .map((childId) => {
          return props.company.roles[childId]?.surroundingMeRoles?.find(
            (it: number) => {
              return props.company.roles[it].roleType === 'District';
            }
          );
        })
        .filter((c) => !!c);
      districts.forEach((district) =>
        it.targetRolesId.forEach((it) => {
          targetRolesToManage.push([district, it]);
        })
      );
    }
  });
  const isTargetUser = (it?: ICompanyMember) => {
    if (!it) return false;
    const isTargetUser =
      (props.isPDPAdmin || managementApplies(it)) &&
      Object.keys(it.roles).some((r) => {
        return props?.term?.id
          ? props.pdpState.terms?.[
              props?.term?.id
            ]?.term?.properties?.targetRoleIds?.includes(Number(r))
          : false;
      }) &&
      (!selectedDistrict || it.roles[selectedDistrict]) &&
      (!selectedPost || it.roles[selectedPost]);
    if (isTargetUser) targetUserIds.push(it.userId);
    return !personPrograms![it.userId] && isTargetUser;
  };

  const missingUserIdsForSelf = personPrograms![props.thisUser.userId!]
    ? []
    : [thisUserId].filter((it) => isTargetUser(props.company.members[it]));
  const missingUserIdsManaging = Object.values(props.company.members)
    .filter(isTargetUser)
    ?.map((it) => it.userId)
    .filter((it) => it !== thisUserId);
  const creatableMissingUser = onlySelf
    ? missingUserIdsForSelf
    : missingUserIdsManaging;
  Object.values(personPrograms).forEach((it) => {
    if (it.memberUserId !== thisUserId) {
      Object.keys(props.company.members[it.memberUserId]?.roles || {}).forEach(
        (it) => {
          allCurrentRoleIds.add(Number(it));
        }
      );
    }
  });

  const allRolesValue = -100;
  const allRoles = Object.values(props.company.roles) as ICompanyRole[];
  let allRoleOptions =
    allRoles
      ?.filter((it) => !it.isProjectRole && allCurrentRoleIds.has(it.id))
      ?.map((it) => ({ value: it.id, label: it.displayName || '' })) || [];
  allRoleOptions = [
    { label: messages.allUsers, value: allRolesValue },
    ...allRoleOptions,
  ];
  const allRoleForTopicOptions =
    allRoles
      ?.filter((it) => !it.isProjectRole)
      ?.map((it) => ({ value: it.id!, label: it.displayName || '' })) || [];
  const tagOptions: IOption[] = [];
  Object.values(props.tags).forEach((it: ITagView) => {
    if (
      it.parentId &&
      (selectedPdpCompany.properties.topicTags.includes(it.parentId) ||
        selectedPdpCompany.properties.topicTagsInPDP.includes(it.parentId))
    ) {
      tagOptions.push({
        value: it.id,
        label: it.text,
        parent: it.parentId,
      });
    } else if (
      selectedPdpCompany.properties.topicTags.includes(Number(it.id)) ||
      selectedPdpCompany.properties.topicTagsInPDP.includes(Number(it.id))
    ) {
      tagOptions.push({
        value: it.id,
        label: it.text,
        disabled: true,
      });
    }
  });

  function managementApplies(user: ICompanyMember | undefined) {
    if (!user) return false;
    if (
      phase &&
      phase?.whoManagesWhom?.length === 0 &&
      user.userId === thisUserId
    )
      return true;
    const rolesOfTheUser = Object.keys(user?.roles).map((it) => Number(it));
    return !!targetRolesToManage.find((r) => hasAll(rolesOfTheUser, r));
  }
  const batchAddUserIds = [] as number[];

  if (selectedBatchAddTopic && selectedBatchAddRoleOption.length)
    Object.values(personPrograms).forEach((it) => {
      const rolesOfTheUser = Object.keys(
        props.company.members[it.memberUserId]?.roles || {}
      ).map((it) => Number(it));
      if (
        (props.isPDPAdmin ||
          managementApplies(props.company.members[it.memberUserId])) &&
        rolesOfTheUser.some((it) =>
          selectedBatchAddRoleOption?.some(
            (that) =>
              Number(that.value) === allRolesValue || Number(that.value) === it
          )
        ) &&
        selectedBatchAddTopic &&
        (!props.pdpState.topics![selectedBatchAddTopic].properties
          .relatedToRoles.length ||
          rolesOfTheUser.some((it) =>
            props.pdpState.topics![
              selectedBatchAddTopic
            ].properties.relatedToRoles.includes(it)
          ))
      )
        batchAddUserIds.push(it.memberUserId);
    });

  const performBatchDelete = (topicId: number, batchAddKey: string) => {
    let toUpdate = Object.values(personPrograms).filter((it) =>
      it.properties.topics.find((it) => it.topicId === topicId)
    );
    toUpdate = toUpdate.map((it) => {
      const clone = cloneDeep(it);
      clone.properties.topics = clone.properties.topics.filter(
        (it) => it.topicId !== topicId
      );
      return clone;
    });
    if (!toUpdate.length) {
      return;
    }
    const newSet = new Set(addingBatch);
    newSet.add(batchAddKey);
    setAddingBatch(newSet);
    props
      .createOrUpdateBatchPDPProgram(toUpdate, pdpId!)
      .catch((reason: any) => {
        notifyError(reason);
      })
      .then(() => {
        notify(
          messages.batchAddSuccessful(
            toUpdate.length,
            props.pdpState.topics![topicId!]!.properties.name,
            'delete'
          )
        );
      })
      .finally(() => {
        const newSet = new Set(addingBatch);
        newSet.delete(batchAddKey);
        setAddingBatch(newSet);
        setSelectedTopicToView(undefined);
      });
  };
  const performBatchAdd = (
    targetUserIds: number[],
    topicId: number,
    batchAddKey: string,
    type: ApproveState = 'Approved',
    tags?: number[],
    toRemoveTags?: number[],
    toAddTags?: number[]
  ) => {
    const programs = [] as PDPProgram[];
    Object.values(personPrograms).forEach((program) => {
      if (
        !targetUserIds.includes(program.memberUserId) ||
        !editableUsers.has(program.memberUserId)
      )
        return;
      const clone = cloneDeep(program) as PDPProgram;
      let current: PersonalTermTopic | undefined = clone.properties.topics.find(
        (it) => it.topicId === topicId
      );
      if (!current) {
        current = {
          addedInPhase: phase?.id,
          addedByUser: thisUserId,
          topicId: topicId,
          approvedStateByUsers: [],
        } as PersonalTermTopic;
        clone.properties.topics.push(current);
      }
      let currentApprove = current.approvedStateByUsers.find(
        (it) => it.phaseId === phase?.id || (shadowPhase?.id as any)
      );

      if (
        type === 'Rejected' &&
        (current.addedInPhase === phase?.id || (shadowPhase?.id as any))
      ) {
        clone.properties.topics = clone.properties.topics.filter(
          (it) => it.topicId !== topicId
        );
      } else if (currentApprove) {
        currentApprove.approved = type;
        currentApprove.userId = thisUserId;
        currentApprove.tags = tags || currentApprove.tags || [];
      } else {
        currentApprove = {
          approved: type,
          userId: thisUserId,
          phaseId: (phase?.id as any) || (shadowPhase?.id as any),
          tags: tags || [],
        };
        current.approvedStateByUsers.push(currentApprove);
      }
      if (currentApprove) {
        if (currentApprove!.tags.length === 0) {
          currentApprove!.tags =
            [...current.approvedStateByUsers]
              .reverse()
              .find((it) => it.approved && it.tags.length > 0)?.tags || [];
        }
        if (toRemoveTags || toAddTags)
          currentApprove!.tags = currentApprove!.tags.filter(
            (it) => !toRemoveTags?.includes(it) && !toAddTags?.includes(it)
          );
        if (toAddTags)
          currentApprove!.tags = [...currentApprove!.tags, ...toAddTags];
      }

      programs.push(clone);
    });
    if (programs.length === 0) {
      notify(messages.done);
      return;
    }
    const newSet = new Set(addingBatch);
    newSet.add(batchAddKey);
    setAddingBatch(newSet);
    props
      .createOrUpdateBatchPDPProgram(programs, pdpId!)
      .catch((reason: any) => {
        notifyError(reason);
      })
      .then(() => {
        notify(
          messages.batchAddSuccessful(
            programs.length,
            props.pdpState.topics![topicId!]!.properties.name,
            type
          )
        );
      })
      .finally(() => {
        const newSet = new Set(addingBatch);
        newSet.delete(batchAddKey);
        setAddingBatch(newSet);
      });
  };

  const topicStats = {} as { [key: number]: TopicStats };
  const personStats = {} as {
    [key: number]: {
      approved: number;
      rejected: number;
      unknown: number;
      previousRejected: number;
    };
  };

  const allowApprove =
    phase?.validActions.length === 0 || phase?.validActions.includes('Approve');
  const editableUsers = new Set<number>();
  const filteredUserIds = new Set<number>();

  Object.values(personPrograms).forEach((program: PDPProgram) => {
    const thisPersonStats = {
      approved: 0,
      rejected: 0,
      unknown: 0,
      previousRejected: 0,
    };
    if (
      (!selectedDistrict ||
        props.company.members[program.memberUserId]?.roles?.[
          selectedDistrict
        ]) &&
      (!selectedPost ||
        props.company.members[program.memberUserId]?.roles?.[selectedPost])
    )
      filteredUserIds.add(program.memberUserId);
    else return;
    if (
      props.isPDPAdmin ||
      (onlySelf && program.memberUserId === thisUserId) ||
      managementApplies(props.company.members[program.memberUserId!])
    )
      editableUsers.add(program.memberUserId);
    personStats[program.memberUserId] = thisPersonStats;
    program.properties.topics.forEach((ptt) => {
      const currentPhaseState = ptt.approvedStateByUsers.find(
        (it, index, list) =>
          it.phaseId === phase?.id || index === list.length - 1
      )?.approved;
      const isMandatory = !!props.pdpState.topics![
        ptt.topicId!
      ].properties.mandatoryForRoles.find(
        (role) => !!props.company.members[program.memberUserId]?.roles?.[role]
      );
      const currentState =
        ptt.approvedStateByUsers[ptt.approvedStateByUsers.length - 1]
          ?.approved || 'Approved';
      const currentTags =
        ptt.approvedStateByUsers[ptt.approvedStateByUsers.length - 1]?.tags;
      if (!topicStats[ptt.topicId]) topicStats[ptt.topicId] = newTopicStats();

      function addTagStats() {
        currentTags?.forEach((it) => {
          if (!topicStats[ptt.topicId][it]) topicStats[ptt.topicId][it] = 1;
          else topicStats[ptt.topicId][it]++;
        });
      }

      switch (currentPhaseState) {
        case 'Approved':
          addTagStats();
          thisPersonStats.approved++;
          topicStats[ptt.topicId].approved.push(program.memberUserId);
          break;
        case 'Rejected':
          thisPersonStats.rejected++;
          topicStats[ptt.topicId].rejected.push(program.memberUserId);
          break;
        case undefined:
          switch (currentState) {
            case 'Approved':
              addTagStats();
              if (editableUsers.has(program.memberUserId) && allowApprove) {
                if (isMandatory) {
                  thisPersonStats.approved++;
                  topicStats[ptt.topicId].approved.push(program.memberUserId);
                } else {
                  thisPersonStats.unknown++;
                  topicStats[ptt.topicId].unknown.push(program.memberUserId);
                }
              } else {
                thisPersonStats.approved++;
                topicStats[ptt.topicId].approved.push(program.memberUserId);
              }
              break;
            case 'Rejected':
              thisPersonStats.previousRejected++;
              topicStats[ptt.topicId].previousRejected.push(
                program.memberUserId
              );
              break;
            case undefined:
              if (isMandatory) {
                thisPersonStats.approved++;
                topicStats[ptt.topicId].approved.push(program.memberUserId);
              } else {
                addTagStats();
                thisPersonStats.unknown++;
                topicStats[ptt.topicId].unknown.push(program.memberUserId);
              }
              break;
          }
          break;
      }
    });
  });

  const filteredPrograms = Object.values(personPrograms).filter(
    (it) =>
      filteredUserIds.has(it.memberUserId) && it.memberUserId !== thisUserId
  );
  Object.values(props.pdpState.topics || {}).forEach((topic: Topic) => {
    if (topic.status === 'Archived' || topic.status === 'Disabled') return;
    targetUserIds.forEach((userId) => {
      if (
        !(
          (!selectedDistrict ||
            props.company.members[userId]?.roles?.[selectedDistrict]) &&
          (!selectedPost ||
            props.company.members[userId]?.roles?.[selectedPost])
        )
      ) {
        return;
      }
      const mandatory = props.pdpState.topics![
        topic.id!
      ].properties.mandatoryForRoles.filter(
        (role) => !!props.company.members[userId]?.roles?.[role]
      );
      const optionalRoles = mandatory.length
        ? []
        : props.pdpState.topics![topic.id!].properties.relatedToRoles.filter(
            (role) => !!props.company.members[userId]?.roles?.[role]
          );
      const optional =
        !mandatory.length &&
        props.pdpState.topics![topic.id!].status === 'Exists' &&
        props.pdpState.topics![topic.id!].properties.relatedToRoles.some(
          (role) => !!props.company.members[userId]?.roles?.[role]
        );
      if (mandatory.length || optional)
        if (!topicStats[topic.id!]) {
          topicStats[topic.id!] = newTopicStats();
        }
      const approved = topicStats[topic.id!]?.approved?.includes(userId)
        ? 1
        : 0;
      if (mandatory.length) {
        topicStats[topic.id!].mandatoryUsers.push(userId);
        topicStats[topic.id!].mandatoryApprovedUserCount += approved;
        mandatory.forEach((mandatoryRoleId) => {
          if (!topicStats[topic.id!].mandatoryRoleStats[mandatoryRoleId])
            topicStats[topic.id!].mandatoryRoleStats[mandatoryRoleId] = {
              allUsers: [],
              approvedUsers: [],
              rejectedUsers: [],
              unknownUsers: [],
            };
          const stat =
            topicStats[topic.id!].mandatoryRoleStats[mandatoryRoleId];
          stat.allUsers.push(userId);
          if (approved) stat.approvedUsers.push(userId);
          else if (topicStats[topic.id!]?.rejected?.includes(userId))
            stat.rejectedUsers.push(userId);
          else if (topicStats[topic.id!]?.unknown?.includes(userId))
            stat.unknownUsers.push(userId);
        });
      } else if (optional) {
        topicStats[topic.id!].optionalUsers.push(userId);
        topicStats[topic.id!].optionalApprovedUserCount += approved;
        optionalRoles.forEach((optional) => {
          if (!topicStats[topic.id!].optionalRoleStats[optional])
            topicStats[topic.id!].optionalRoleStats[optional] = {
              allUsers: [],
              approvedUsers: [],
              rejectedUsers: [],
              unknownUsers: [],
            };
          const stat = topicStats[topic.id!].optionalRoleStats[optional];
          stat.allUsers.push(userId);
          if (approved) stat.approvedUsers.push(userId);
          else if (topicStats[topic.id!]?.rejected?.includes(userId))
            stat.rejectedUsers.push(userId);
          else if (topicStats[topic.id!]?.unknown?.includes(userId))
            stat.unknownUsers.push(userId);
        });
      } else {
        if (
          topicStats[topic.id!] &&
          topicStats[topic.id!].approved.includes(userId)
        ) {
          topicStats[topic.id!].notRelatedUsers.push(userId);
          topicStats[topic.id!].notRelatedApprovedUserCount += 1;
        }
      }
    });
  });
  const showReportPart =
    Object.keys(personPrograms).length > 1 || props.isPDPAdmin;

  const handleGetProgramsExport = () => {
    const term = props.pdpState.terms![props!.term!.id!]!.term!;
    const phases = term.properties.phaseConfig.phases;
    const headerRow: any = {
      user: messages.name,
      roles: messages.roles,
      mandatory: messages.mandatory,
    };
    phases.forEach((phase) => {
      headerRow['phase_' + phase.id] = phase.name;
    });

    const data = [headerRow];

    const formatTopicCell = (topic: PersonalTermTopic) => {
      const topicData = props.pdpState.topics![topic.topicId];
      const lastApproval =
        topic.approvedStateByUsers[topic.approvedStateByUsers.length - 1];
      const status = lastApproval?.approved || 'Approved';
      const statusEmoji =
        status === 'Approved' ? '✅' : status === 'Rejected' ? '❌' : '⏳';
      let cellValue = statusEmoji + ' ' + topicData.properties.name;

      if (status === 'Rejected') {
        const lastRejection = [...topic.approvedStateByUsers]
          .reverse()
          .find((it: ApprovedStateByUser) => it.approved === 'Rejected');
        if (lastRejection) {
          const rejectedByUser = props.users[lastRejection.userId];
          cellValue += ` ## ${messages.rejectedBy(
            rejectedByUser.name,
            phases.find((it) => it.id === lastRejection.phaseId)?.name || ''
          )}`;
        }
      }
      return cellValue;
    };

    Object.values(personPrograms)
      .filter((program) =>
        selectedUserId
          ? program.memberUserId === selectedUserId
          : filteredUserIds.has(program.memberUserId)
      )
      .forEach((program) => {
        const userId = program.memberUserId;
        const member = props.company.members[userId];
        const userDisplayName = props.users[userId].name;
        const roles = Object.keys(member.roles)
          .map((it) => props.company.roles[+it].name)
          .join(', ');
        const employeeId = member.employeeId || '-';

        const mandatoryTopics: PersonalTermTopic[] = [];
        const topicsByPhase: { [phaseId: string]: PersonalTermTopic[] } = {};

        program.properties.topics.forEach((topic) => {
          const isMandatory = !!props.pdpState.topics![
            topic.topicId!
          ].properties.mandatoryForRoles.find(
            (role) => !!props.company.members[userId]?.roles?.[role]
          );

          if (isMandatory) {
            mandatoryTopics.push(topic);
          } else {
            if (!topicsByPhase[topic.addedInPhase])
              topicsByPhase[topic.addedInPhase] = [];
            topicsByPhase[topic.addedInPhase].push(topic);
          }
        });

        let maxTopicsInPhase = mandatoryTopics.length;
        phases.forEach((phase) => {
          const count = topicsByPhase[phase.id]?.length || 0;
          if (count > maxTopicsInPhase) maxTopicsInPhase = count;
        });

        const approvedCount = program.properties.topics.filter(
          (it) =>
            it.approvedStateByUsers[it.approvedStateByUsers.length - 1]
              .approved === 'Approved'
        ).length;
        const rejectedCount = program.properties.topics.length - approvedCount;

        for (let i = 0; i < Math.max(maxTopicsInPhase, 1); i++) {
          const rowData: any = {
            user: userDisplayName + (employeeId ? `(${employeeId})` : ''),
            roles: roles,
            mandatory: mandatoryTopics[i]
              ? formatTopicCell(mandatoryTopics[i])
              : '',
          };

          phases.forEach((phase) => {
            const topicsInPhase = topicsByPhase[phase.id] || [];
            rowData['phase_' + phase.id] = topicsInPhase[i]
              ? formatTopicCell(topicsInPhase[i])
              : '';
          });

          data.push(rowData);
        }

        const summaryRow: any = {
          user: userDisplayName + (employeeId ? `(${employeeId})` : ''),
          roles: roles,
          mandatory: '',
        };
        phases.forEach((phase, index) => {
          summaryRow['phase_' + phase.id] = '';
          if (index === phases.length - 1) {
            summaryRow['phase_' + phase.id] =
              `✅${messages.approved}: ${convertNumbersToProperFormat(approvedCount)}  -   ❌${messages.rejected}: ${convertNumbersToProperFormat(rejectedCount)}  `;
          }
          summaryRow.isTotal = true;
        });
        data.push(summaryRow);
      });

    return data;
  };
  const createMissingPrograms = () => {
    const programs = creatableMissingUser.map((id) => {
      const clone = {
        id: null as any,
        termId: props.term!.id!,
        memberUserId: id,
        properties: {
          topics: [],
        } as TermPersonProposedProgramProperties,
      };
      const mandatorPrograms = Object.values(
        props.pdpState.topics || {}
      ).filter(
        (it: Topic) =>
          it.status === 'Exists' &&
          it.properties.mandatoryForRoles.some(
            (role) => !!props.company.members[clone.memberUserId]?.roles?.[role]
          )
      );
      clone.properties.topics = mandatorPrograms.map((t) => ({
        topicId: t.id!,
        addedByUser: thisUserId,
        addedInPhase: phase?.id || shadowPhase!.id,
        approvedStateByUsers: [
          {
            userId: thisUserId,
            phaseId: phase?.id || shadowPhase!.id,
            approved: 'Approved',
            tags: [],
          },
        ],
      }));
      return clone as PDPProgram;
    });
    const newSet = new Set(addingBatch);
    newSet.add('missingUser');
    setAddingBatch(newSet);
    props
      .createOrUpdateBatchPDPProgram(programs, pdpId)
      .then(({ programs }: { programs: PDPProgram[] }) => {
        setSelectedUserId(programs[0]?.memberUserId || 0);
      })
      .finally(() => {
        const newSet = new Set(addingBatch);
        newSet.delete('missingUser');
        setAddingBatch(newSet);
      });
  };

  function createClass(
    topicId: number,
    foundClass: PDPClass | undefined,
    toAddUsers?: number[]
  ) {
    if (!foundClass) {
      foundClass = {
        topicId: topicId,
        properties: {
          phaseProps:
            selectedPdpCompany.properties.classPhaseDefaultProps || [],
          classDocumentHomeId: undefined as any,
        },
        participants: [],
      } as any;
    }
    setCreatingClass([...creatingClass, topicId]);
    const clazz = cloneDeep(foundClass!) as PDPClass;
    clazz.id = undefined as any;
    clazz.startDate = props.term?.startDate || Date.now();
    clazz.endDate = props.term?.endDate || Date.now();
    clazz.template = false;
    clazz.relatedTermIds = [props.term!.id!];
    props
      .createOrUpdateClass(clazz, selectedPdpCompany.id)
      .then(({ classes }: { classes: PDPClass[] }) => {
        setCreatingClass(creatingClass.filter((it) => it === topicId));
        if (toAddUsers && toAddUsers.length)
          addAllUsersToClass(toAddUsers, classes[0]!).finally(() => {
            navigate(`./class/${classes[0]!.id}#edit`);
          });
        else navigate(`./class/${classes[0]!.id}#edit`);
      });
  }
  function addTermToClass(
    foundClass: PDPClass,
    termId: number,
    toAddUsers: number[]
  ) {
    setCreatingClass([...creatingClass, foundClass.topicId]);
    const clazz = cloneDeep(foundClass!) as PDPClass;
    clazz.relatedTermIds.push(termId);
    clazz.relatedTermIds = removeDuplicates(clazz.relatedTermIds);
    props.createOrUpdateClass(clazz, pdpId).then(() => {
      notify(
        messages.classNowSupportsMembersOfProgram(
          props.pdpState.topics![clazz.topicId].properties.name,
          props.pdpState.terms![termId]!.term?.properties?.name || ''
        )
      );
      if (toAddUsers && toAddUsers.length)
        addAllUsersToClass(toAddUsers, clazz!).finally(() => {
          navigate(`./class/${clazz!.id}#edit`);
        });
      else navigate(`./class/${clazz!.id}#edit`);
      setCreatingClass(creatingClass.filter((it) => it === foundClass.topicId));
    });
  }

  function addAllUsersToClass(
    notInClass: number[],
    foundClass: PDPClass
  ): Promise<any> {
    const naddingBatch = cloneDeep(addingBatch);
    naddingBatch.add('class' + foundClass.topicId);
    setAddingBatch(naddingBatch);
    return props
      .addParticipantsToClass(pdpId, foundClass.id, notInClass)
      .then(
        (pdpClass: any) => {
          const foundUsers = notInClass
            .filter((it) => pdpClass.participants[it])
            .map((it) => props.users[it].name)
            .join(messages.comma + ' ');
          notify(
            messages.usersAddedToClass(
              foundUsers,
              props.pdpState.topics![pdpClass.topicId].properties.name
            )
          );
        },
        (reason: any) => {
          notifyError(reason);
        }
      )
      .finally(() => {
        const naddingBatch = cloneDeep(addingBatch);
        naddingBatch.delete('class' + foundClass.topicId);
        setAddingBatch(naddingBatch);
      });
  }
  function requestTopic(name: string) {
    setRequestingTopic(true);
    name = name + '*';
    props
      .addNewTopic({
        properties: {
          name,
          tags: [],
          relatedToRoles: [],
          mandatoryForRoles: [],
        },
        companyPDPId: pdpId,
        status: 'Proposed',
      })
      .then(({ topic }: { topic: Topic }) => {
        setSelectedBatchAddTopic(topic.id!);
      })
      .finally(() => {
        setRequestingTopic(false);
        setRequestingNewTopicModalOpen(false);
      });
  }

  function getCardPreview(it: PDPProgram, style?: any) {
    const thisPersonStats = personStats[it.memberUserId];
    const pdpProblems = getPDPProblems(
      it,
      props.term!,
      props.pdpState,
      props.company,
      props.tags
    );
    const hasError = pdpProblems.some((it) => it.level === 'error');
    const hasWarn = pdpProblems.some((it) => it.level === 'warning');
    const firstPhase =
      props.term?.properties.phaseConfig.phases?.reduce(
        (current, item) => Math.min(current, item.startDate!),
        1e100
      ) === phase?.startDate;

    return (
      <Card
        key={it.memberUserId}
        onClick={() => {
          if (!dirty || confirm(messages.changesNotSaved))
            setSelectedUserId(it.memberUserId!);
        }}
        style={{
          ...(style || {}),
          flexDirection: 'row',
          justifyContent: 'space-between',
          cursor: 'pointer',
          flexGrow: 0,
          backgroundColor:
            it.memberUserId === selectedUserId ? lightGreenSolid : undefined,
        }}
      >
        <div>{props.users[it.memberUserId]?.name}</div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
          }}
        >
          {hasError &&
            withTitle(
              <Icon
                type="alert-triangle"
                color={red}
                style={{ marginInlineEnd: '5px' }}
              />,
              messages.pdpWithError
            )}
          {hasWarn &&
            !hasError &&
            withTitle(
              <Icon
                type="alert-octagon"
                color={orange}
                style={{ marginInlineEnd: '5px' }}
              />,
              messages.pdpHasWarn
            )}
          {!!thisPersonStats?.unknown &&
            withTitle(
              <Badge color={lightYellowSolid} textColor={black}>
                {convertDigitToProperFormat(thisPersonStats.unknown)}?
              </Badge>,
              messages.unknown
            )}
          {withTitle(
            <Badge color={firstPhase ? blue : green}>
              <Icon type={firstPhase ? 'plus' : 'check'} color={white} />
              {convertDigitToProperFormat(thisPersonStats?.approved)}
            </Badge>,
            firstPhase ? messages.added : messages.approved
          )}
          {!firstPhase &&
            withTitle(
              <Badge color={lightRed}>
                <Icon type={'x'} color={white} />
                {convertDigitToProperFormat(
                  (thisPersonStats?.rejected || 0) +
                    (thisPersonStats?.previousRejected || 0)
                )}
              </Badge>,
              messages.rejected
            )}
        </div>
      </Card>
    );
  }

  const getCardPreviewInList = (childProps: ListChildComponentProps & any) => {
    const it = childProps.data.filteredPrograms[childProps.index];
    return <div style={childProps.style}>{getCardPreview(it)}</div>;
  };

  const getPersonInApprovedList = (
    childProps: ListChildComponentProps & any
  ) => {
    const it = childProps.data.items[childProps.index];
    const foundClass = childProps.data.foundClass;
    const topicStat = childProps.data.topicStat;
    const topicId = childProps.data.topicId;
    return (
      <div style={childProps.style}>
        {getApproveGroupItem(it, topicStat, topicId, foundClass)}
      </div>
    );
  };

  const userId = thisUserId;
  const newTopicCount = Object.values(props.pdpState.topics || {}).filter(
    (t) =>
      t.status === 'Proposed' &&
      topicStats[t.id!] &&
      (topicStats[t.id!].approved.length > 0 ||
        topicStats[t.id!].rejected.length > 0 ||
        topicStats[t.id!].unknown.length > 0)
  ).length;

  function handleSearchTopicState(e: ChangeEvent<HTMLInputElement>) {
    const searchText = e.target.value;
    setSearchedTopicState(searchText);
  }

  function getAllUserStats(
    topic: Topic,
    header: string,
    roleStats: RoleStats,
    roleList: number[]
  ) {
    return (
      <Collapsible
        header={header}
        style={{ width: '100%' }}
        customBodyStyle={{ overflow: 'auto' }}
      >
        <table className="highlightedTable align-center-table">
          <thead>
            <tr>
              <th>{messages.role}</th>
              <th>{messages.userCount}</th>
              <th>{messages.approved}</th>
              <th>{messages.rejected}</th>
              <th>{messages.unknown}</th>
              <th>{messages.actions}</th>
            </tr>
          </thead>
          {roleList.map((roleId) => {
            return (
              <tr key={roleId} className="hover-area">
                <td>{props.company.roles[roleId]?.name}</td>
                <td>
                  {convertDigitToProperFormat(
                    roleStats[roleId]?.allUsers.length || 0
                  )}
                </td>
                <td>
                  {convertDigitToProperFormat(
                    roleStats[roleId]?.approvedUsers.length || 0
                  )}{' '}
                  (
                  {convertNumbersToProperFormat(
                    ((roleStats[roleId]?.approvedUsers.length || 0) /
                      (roleStats[roleId]?.allUsers.length || 1)) *
                      100,
                    0
                  )}
                  ٪)
                </td>
                <td>
                  {convertDigitToProperFormat(
                    roleStats[roleId]?.rejectedUsers.length || 0
                  )}{' '}
                  (
                  {convertNumbersToProperFormat(
                    ((roleStats[roleId]?.rejectedUsers.length || 0) /
                      (roleStats[roleId]?.allUsers.length || 1)) *
                      100,
                    0
                  )}
                  ٪)
                </td>
                <td>
                  {convertDigitToProperFormat(
                    roleStats[roleId]?.unknownUsers.length || 0
                  )}
                </td>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '10px',
                    }}
                    className={'visible-on-hover'}
                  >
                    <APopover
                      curveBorder
                      arrow
                      target={
                        <Button>
                          <Icon type="arrow-left" />
                          {messages.actionDots}
                        </Button>
                      }
                      usePortal={true}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px',
                        }}
                      >
                        <div>{props.company.roles[roleId]?.name}</div>
                        <Button
                          color={'green'}
                          loading={addingBatch.has(
                            'all' + topic.id + 'role' + roleId + 'g'
                          )}
                          onClick={() => {
                            performBatchAdd(
                              roleStats[roleId]?.unknownUsers,
                              topic.id!,
                              'all' + topic.id + 'role' + roleId + 'g'
                            );
                          }}
                        >
                          <Icon type="check" />
                          {messages.approveAllWaiting}
                        </Button>
                        <Button
                          color={'green-outline'}
                          loading={addingBatch.has(
                            'all' + topic.id + 'role' + roleId + 'go'
                          )}
                          onClick={() => {
                            performBatchAdd(
                              [
                                ...roleStats[roleId]?.unknownUsers,
                                ...roleStats[roleId]?.rejectedUsers,
                              ],
                              topic.id!,
                              'all' + topic.id + 'role' + roleId + 'go'
                            );
                          }}
                        >
                          <Icon type="check" />
                          {messages.approveAllRequested}
                        </Button>
                        <Button
                          color={'red'}
                          loading={addingBatch.has(
                            'all' + topic.id + 'role' + roleId + 'r'
                          )}
                          onClick={() => {
                            performBatchAdd(
                              roleStats[roleId]?.unknownUsers,
                              topic.id!,
                              'all' + topic.id + 'role' + roleId + 'r',
                              'Rejected'
                            );
                          }}
                        >
                          <Icon type="x" />
                          {messages.rejectAllWaiting}
                        </Button>{' '}
                        <Button
                          color={'red-outline'}
                          loading={addingBatch.has(
                            'all' + topic.id + 'role' + roleId + 'ro'
                          )}
                          onClick={() => {
                            performBatchAdd(
                              [
                                ...roleStats[roleId]?.unknownUsers,
                                ...roleStats[roleId]?.approvedUsers,
                              ],
                              topic.id!,
                              'all' + topic.id + 'role' + roleId + 'ro',
                              'Rejected'
                            );
                          }}
                        >
                          <Icon type="x" />
                          {messages.rejectAllRequested}
                        </Button>
                        <Button
                          color={'blue-outline'}
                          loading={addingBatch.has(
                            'all' + topic.id + 'role' + roleId
                          )}
                          onClick={() => {
                            performBatchAdd(
                              roleStats[roleId]?.allUsers,
                              topic.id!,
                              'all' + topic.id + 'role' + roleId,
                              'Approved'
                            );
                          }}
                        >
                          <Icon type={'plus'} />
                          {messages.addAllTargetGroup}
                        </Button>
                      </div>
                    </APopover>
                  </div>
                </td>
              </tr>
            );
          })}
        </table>
      </Collapsible>
    );
  }

  function getApproveGroupItem(
    userId: number,
    topicStat: TopicStats,
    topicId: number,
    foundClass?: PDPClass
  ) {
    return (
      <ApproveGroupItem key={userId} className="hover-area">
        <PersonInList
          style={{
            cursor: 'pointer',
            height: '28px',
            color: topicStat.approved.includes(userId)
              ? green
              : editableUsers.has(userId)
                ? black
                : gray,
          }}
          onClick={() => {
            if (!dirty || confirm(messages.changesNotSaved)) {
              setSelectedUserId(userId);
              setSelectedTab('persons');
            }
          }}
          inClass={!!foundClass?.participants[userId]}
        >
          {!!foundClass?.participants[userId] && (
            <Icon
              type="book-open"
              style={{
                padding: '0 0 0 10px',
              }}
              title={messages.classMember}
            />
          )}
          {props.users[userId]?.name}
        </PersonInList>
        {editableUsers.has(userId) && (
          <span className="visible-on-hover">
            {!topicStat.approved.includes(userId) && (
              <HoverIcon
                type="check-circle"
                loading={addingBatch.has(userId + '-' + topicId)}
                title={messages.approve}
                onClick={() => {
                  performBatchAdd(
                    [userId],
                    Number(topicId),
                    userId + '-' + topicId
                  );
                }}
                color={green}
              />
            )}
            {!topicStat.previousRejected.includes(userId) &&
              !topicStat.rejected.includes(userId) && (
                <HoverIcon
                  type="x-circle"
                  loading={addingBatch.has(userId + '-' + topicId + 'reject')}
                  title={messages.reject}
                  onClick={() => {
                    performBatchAdd(
                      [userId],
                      Number(topicId),
                      userId + '-' + topicId + 'reject',
                      'Rejected'
                    );
                  }}
                  color={red}
                />
              )}
          </span>
        )}
      </ApproveGroupItem>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <Header>
        <div style={{ display: 'flex' }}>
          <h5>{props?.term?.properties?.name}</h5>
        </div>
        {showReportPart && (
          <div
            className={'hide-on-mobile'}
            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            <span>{messages.filter}:</span>
            <Select
              values={
                selectedDistrict
                  ? [
                      {
                        value: selectedDistrict,
                        label: props.company.roles[selectedDistrict].name,
                      },
                    ]
                  : []
              }
              options={Object.values(props.company.roles)
                .filter(
                  (it) =>
                    it.roleType === 'District' && allCurrentRoleIds.has(it.id)
                )
                .map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
              placeholder={messages.filterDistrict}
              onChangeValues={(it) => {
                setSelectedDistrict(it.length ? Number(it[0]?.value) : null);
              }}
            />
            <Select
              values={
                selectedPost
                  ? [
                      {
                        value: selectedPost,
                        label: props.company.roles[selectedPost]?.name,
                      },
                    ]
                  : []
              }
              options={Object.values(props.company.roles)
                .filter(
                  (it) => it.roleType === 'Post' && allCurrentRoleIds.has(it.id)
                )
                .map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
              placeholder={messages.filterPost}
              onChangeValues={(it) => {
                setSelectedPost(it.length ? Number(it[0]?.value) : null);
              }}
            />
          </div>
        )}
        <div
          style={{
            display: 'flex',
            gap: '20px',
            alignItems: 'center',
            flexGrow: 1,
            justifyContent: 'space-between',
          }}
        >
          <PhaseInfo>
            <span>
              {messages.currentPhase}:<b> {phase ? phase.name : '-'}</b>
            </span>
            {phase && (
              <span>
                {messages.phaseDuration}:{' '}
                <b>
                  {smartDateDuration(
                    new Date(phase.startDate!),
                    new Date(phase.endDate!)
                  )}
                </b>
              </span>
            )}
          </PhaseInfo>
          {
            <Modal
              mainStyle={{ margin: 'auto', maxHeight: '95%', zIndex: 1000000 }}
              isActive={hintOpen}
              title={messages.phaseHint}
              onClose={() => setHintOpen(false)}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  gap: '20px',
                }}
              >
                <CKEditorField
                  // editor={ClassicEditor}
                  data={phase?.phaseHint?.replace(/\n/g, '<br>')}
                  disabled={true}
                  dir="rtl"
                  config={CKEditorReadOnlyConfig}
                  style={{ flexGrow: 1 }}
                />
                <Button
                  color={'blue-outline'}
                  onClick={() => {
                    localStorage.setItem(hintKey, 'true');
                    setHintOpen(false);
                  }}
                >
                  {messages.understood}
                </Button>
              </div>
            </Modal>
          }
          {phase?.phaseHint && (
            <div style={{ padding: '10px' }}>
              <Button color="blue-outline" onClick={() => setHintOpen(true)}>
                <Icon type={'info'} /> {messages.phaseHint}
              </Button>{' '}
            </div>
          )}
          {showReportPart && (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <ExportExcell
                getData={() => handleGetProgramsExport()}
                exportFileName={messages.report(
                  props.term?.properties?.name || '',
                  smartDateString(
                    props.term?.startDate,
                    false,
                    false,
                    false,
                    'jYYYY'
                  ),
                  messages.programsReport
                )}
                categorizedColumnInformation={{
                  columnNumber: 1,
                  columnTitle: 'user',
                  otherToMergeColumnTitles: ['roles'],
                }}
                body={
                  <Button color="green">
                    <Icon type={'download'} /> {messages.excelExport}
                  </Button>
                }
                width={{
                  0: 30,
                  1: 30,
                  default: 50,
                }}
              />
              <ButtonGroup
                style={{ width: '15rem' }}
                items={{
                  persons: messages.personsTab,
                  topics: messages.topicsTab,
                }}
                onSelect={(e) => setSelectedTab(e as any)}
                selected={selectedTab}
              />
            </div>
          )}
        </div>
      </Header>
      <TermsWrapper>
        {selectedTab === 'persons' && (
          <PersonContainer style={{}}>
            <div style={{ display: 'flex', height: '100%' }}>
              <TagListContainer
                className={selectedUserId ? 'hide-on-mobile' : ''}
              >
                {personPrograms[userId] && (
                  <>
                    <p style={{ margin: '15px 15px 0' }}>
                      {messages.myProgram}:
                    </p>
                    {getCardPreview(personPrograms[userId])}
                  </>
                )}

                {(phase || props.isPDPAdmin) && (
                  <>
                    {(!onlySelf || props.isPDPAdmin) && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          margin: ' 15px 15px 0 ',
                        }}
                      >
                        <p>{messages.myManagingProgram}:</p>
                        <span>
                          ({' '}
                          {convertDigitToProperFormat(filteredPrograms.length)}{' '}
                          {messages.from}{' '}
                          {convertDigitToProperFormat(
                            (missingUserIdsManaging?.length || 0) +
                              filteredPrograms.length
                          )}{' '}
                          {messages.persons})
                        </span>
                      </div>
                    )}
                    <div style={{ margin: '15px 15px 0' }}>
                      {Object.keys(personPrograms).length > 5 && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '10px',
                          }}
                        >
                          <Input
                            id={'filter-name'}
                            type="text"
                            value={filterName || ''}
                            onChange={(e) => setFilterName(e.target.value)}
                            placeholder={messages.searchName}
                            style={{
                              height: '2.3rem',
                            }}
                          />
                          <Select
                            values={[
                              sortPersonsOptions.find(
                                (it) => it.value === personSort
                              )!,
                            ]}
                            containerStyle={{ minWidth: '11rem' }}
                            options={sortPersonsOptions}
                            onChangeValues={(it) => {
                              setPersonSort(it[0].value.toString());
                            }}
                            allowRemove={false}
                          />
                        </div>
                      )}
                      {onlySelf && !!missingUserIdsForSelf.length && (
                        <Button
                          loading={addingBatch.has('missingUser')}
                          onClick={createMissingPrograms}
                        >
                          <Icon type={'plus'} /> {messages.addMyProgram}
                        </Button>
                      )}
                      {!!missingUserIdsManaging?.length && (
                        <Collapsible
                          header={
                            !onlySelf
                              ? messages.addAllMissingProgram(
                                  missingUserIdsManaging.length
                                )
                              : messages.missingProgram(
                                  missingUserIdsManaging.length
                                )
                          }
                        >
                          <div>
                            <ul
                              style={{
                                maxHeight: '50vh',
                                overflow: 'auto',
                                padding: '2px',
                                margin: 0,
                              }}
                            >
                              {missingUserIdsManaging.map((id) => (
                                <li
                                  key={id}
                                  style={{
                                    color: black,
                                  }}
                                >
                                  {props.users[id]?.name}
                                </li>
                              ))}
                            </ul>
                            {!onlySelf && (
                              <Button
                                loading={addingBatch.has('missingUser')}
                                onClick={createMissingPrograms}
                              >
                                {messages.addMissingProgram}
                              </Button>
                            )}
                          </div>
                        </Collapsible>
                      )}
                    </div>
                  </>
                )}
                {
                  <div style={{ overflow: 'hidden', flexGrow: 1 }}>
                    {
                      <AutoSizer style={{ width: '100%' }}>
                        {({ height }: { height: number }) => {
                          let hasAnyProgramOtherThanMine = false;
                          const filteredPrograms = Object.values(personPrograms)
                            .filter((it) => {
                              const notMine = it.memberUserId !== userId;
                              if (notMine) hasAnyProgramOtherThanMine = true;
                              return (
                                filteredUserIds.has(it.memberUserId) &&
                                props.users[it.memberUserId]?.name?.includes(
                                  filterName
                                ) &&
                                notMine
                              );
                            })
                            .sort((a: PDPProgram, b: PDPProgram) => {
                              if (personSort === 'updateDate') {
                                return (
                                  (b.properties.updateDate || 0) -
                                  (a.properties.updateDate || 0)
                                );
                              } else if (personSort === 'creationDate') {
                                return (
                                  (b.properties.creationDate || 0) -
                                  (a.properties.creationDate || 0)
                                );
                              } else
                                return props.users[
                                  a.memberUserId
                                ].name.localeCompare(
                                  props.users[b.memberUserId].name
                                );
                            });
                          if (hasAnyProgramOtherThanMine)
                            return (
                              <List
                                width="100%"
                                height={height} // space from bottom
                                itemData={{
                                  filteredPrograms,
                                }}
                                itemSize={60}
                                itemCount={filteredPrograms.length}
                                direction="rtl"
                                style={{
                                  // borderRadius: '15px',
                                  // border: `1px solid ${lightGray}`,
                                  overflow: 'overlay',
                                }}
                              >
                                {getCardPreviewInList}
                              </List>
                            );
                          return <div></div>;
                        }}
                      </AutoSizer>
                    }
                  </div>
                }
              </TagListContainer>
              {selectedUserId &&
              personPrograms[selectedUserId] &&
              props.pdpState.terms ? (
                <PDPPersonEditor
                  editable={
                    selectedUserId === -1 ||
                    (onlySelf && selectedUserId === thisUserId) ||
                    (selectedUserId > 0 &&
                      (props.isPDPAdmin ||
                        managementApplies(
                          props.company.members[selectedUserId]
                        )))
                  }
                  addNewTopic={props.addNewTopic}
                  phase={phase}
                  isPDPAdmin={props.isPDPAdmin}
                  availableUsersToAdd={creatableMissingUser}
                  users={props.users}
                  new={selectedUserId === -1}
                  term={props.term}
                  program={personPrograms[selectedUserId]}
                  selectTagOptions={tagOptions}
                  createOrUpdatePDPProgram={(it) => {
                    return props
                      .createOrUpdatePDPProgram(it, pdpId)
                      .then(({ programs }: { programs: PDPProgram[] }) => {
                        setSelectedUserId(programs[0].memberUserId);
                      }) as any;
                  }}
                  deletePDPProgram={(it) => {
                    return props.deletePDPProgram(it, pdpId).then(() => {
                      setSelectedUserId(null);
                    }) as any;
                  }}
                  pdpState={props.pdpState}
                  thisUser={props.thisUser}
                  allTags={props.tags}
                  pdpId={pdpId!}
                  company={props.company}
                  getErrors={(it: PDPProgram) =>
                    getPDPProblems(
                      it,
                      props.term!,
                      props.pdpState,
                      props.company,
                      props.tags
                    )
                  }
                  setDirty={setDirty}
                  close={(ignoreChanges?: boolean) => {
                    if (
                      !dirty ||
                      ignoreChanges ||
                      confirm(messages.changesNotSaved)
                    )
                      setSelectedUserId(0);
                  }}
                /> /*: Object.keys(
                  props.pdpState.terms?.[Number(props.termId)]
                    ?.personPrograms || {}
                ).length > 0 ? (
                <Card>{messages.selectAMember}</Card>
              ) */
              ) : (
                <div />
              )}
            </div>
          </PersonContainer>
        )}
        {selectedTab === 'topics' && (
          <div
            style={{ display: 'flex', alignItems: 'stretch', width: '100%' }}
          >
            <Container
              className={'hide-on-mobile'}
              style={{
                flexBasis: '20rem',
                flexShrink: 0,
                maxWidth: '45rem',
                overflow: 'auto',
              }}
            >
              {
                <Collapsible
                  style={{ flex: 1 }}
                  customHeaderStyle={{ width: '100%' }}
                  isOpen={true}
                  header={
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div className="flex flex-col ">
                        <div className="text-sm">{messages.topicStats} </div>
                        <Input
                          id={'search-topic-state'}
                          type="text"
                          onChange={handleSearchTopicState}
                          placeholder={messages.searchTopic}
                        />
                      </div>
                      {newTopicCount ? (
                        <a
                          onClick={() => {
                            setSortTopics((old) =>
                              old !== 'suggestCount'
                                ? 'suggestCount'
                                : 'requestCount'
                            );
                          }}
                        >
                          {messages.newTopics(newTopicCount)}{' '}
                        </a>
                      ) : (
                        <></>
                      )}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div className="text-sm">{messages.orderBy}</div>
                        <SelectWithPopover
                          containerStyle={{ width: '200px' }}
                          allowRemove={false}
                          inputStyle={{ margin: 0 }}
                          onChangeValues={(values) =>
                            setSortTopics(values[0].value as any)
                          }
                          options={sortOptions}
                          values={sortOptions.filter(
                            (it) => it.value === sortTopics
                          )}
                        />
                      </div>
                    </div>
                  }
                  defaultOpen
                  nested
                >
                  <>
                    {Object.entries(topicStats)
                      .filter((a) => {
                        return (
                          sortTopics !== 'suggestCount' ||
                          props.pdpState.topics?.[Number(a[0])].status ===
                            'Proposed'
                        );
                      })
                      .sort((a, b) => {
                        switch (sortTopics) {
                          case 'alphabetic':
                            return (
                              props.pdpState.topics?.[Number(a[0])].properties
                                .name || ''
                            ).localeCompare(
                              props.pdpState.topics?.[Number(b[0])].properties
                                .name || ''
                            );
                          case 'approvedCount':
                            return b[1].approved.length - a[1].approved.length;
                          case 'requestCount':
                          case 'suggestCount':
                            return (
                              b[1].approved.length +
                              b[1].rejected.length +
                              b[1].unknown.length -
                              (a[1].approved.length +
                                a[1].rejected.length +
                                a[1].unknown.length)
                            );
                          case 'waitingCount':
                            return b[1].unknown.length - a[1].unknown.length;
                        }
                      })
                      .map((topicStat) => {
                        const topicId = Number(topicStat[0]);
                        const topic = props.pdpState.topics?.[topicId];
                        if (!topic) return <></>;
                        if (
                          searchedTopicState.length > 0 &&
                          !topic.properties.name.includes(searchedTopicState)
                        ) {
                          return <></>;
                        }
                        const foundClass = Object.values(
                          props.pdpState.classes || {}
                        ).find(
                          (c) =>
                            c.topicId === topicId &&
                            !c.deleted &&
                            c.relatedTermIds.includes(props.term!.id!)
                        );
                        let crateClassOptions = [] as PDPClass[];
                        if (!foundClass) {
                          const now = new Date().getTime();
                          crateClassOptions = Object.values(
                            props.pdpState.classes || {}
                          ).filter(
                            (c) =>
                              c.topicId === topicId &&
                              !c.template &&
                              !c.deleted &&
                              (!c.endDate || c.endDate > now)
                          );
                          crateClassOptions.push({
                            properties: {
                              phaseProps:
                                selectedPdpCompany.properties
                                  .classPhaseDefaultProps || [],
                              allowChooseGroup: 'AllowChange',
                              classGroups: [],
                              classDocumentHomeId: null as any,
                              autoApproveProps: {
                                autoApproveEnabled: false,
                                phaseList: [],
                              },
                            },
                            id: undefined as any,
                            participants: [],
                            relatedTermIds: [],
                            topicId: topicId,
                            template: true,
                          });
                        }
                        return (
                          <div
                            key={topicId}
                            style={{
                              display: 'flex',
                              width: '100%',
                              flexWrap: 'wrap',
                              justifyContent: 'space-between',
                              gap: '2px',
                              background:
                                selectedTopicToView === topicId
                                  ? lightGreenSolid
                                  : undefined,
                              borderBottom: `1px solid ${lightGray}`,
                              padding: '5px',
                            }}
                            onClick={() => setSelectedTopicToView(topicId)}
                          >
                            <div
                              style={{
                                width: '200px',
                                color:
                                  props.pdpState.topics![topicId].status ===
                                  'Archived'
                                    ? red
                                    : undefined,
                              }}
                            >
                              {props.pdpState.topics![topicId].properties.name}
                              {props.pdpState.topics![topicId].status ===
                              'Disabled'
                                ? ` (${messages.disabled})`
                                : props.pdpState.topics![topicId].status ===
                                    'Archived'
                                  ? ` (${messages.deleted})`
                                  : ''}
                            </div>
                            <span>
                              <span
                                style={{
                                  color: green,
                                  marginInlineEnd: '10px',
                                }}
                              >
                                <b>{messages.approved}:</b>
                              </span>
                              <Badge color={lightGreenSolid} textColor={black}>
                                {convertDigitToProperFormat(
                                  topicStat[1].approved.length
                                )}
                              </Badge>
                            </span>
                            <span>
                              <span
                                style={{ color: red, marginInlineEnd: '10px' }}
                              >
                                <b>{messages.rejected}:</b>
                              </span>
                              <Badge color={lightRedSolid} textColor={black}>
                                {convertDigitToProperFormat(
                                  topicStat[1].rejected.length
                                )}
                              </Badge>
                            </span>
                            <span
                              style={{
                                color: gray,
                                backgroundColor: topicStat[1].unknown.length
                                  ? lightYellowSolid
                                  : 'unset',
                                padding: '0px 10px',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <span>
                                <b>{messages.unknown}:</b>
                              </span>
                              <Badge color={yellow} textColor={black}>
                                {convertDigitToProperFormat(
                                  topicStat[1].unknown.length
                                )}
                              </Badge>
                            </span>
                          </div>
                        );
                      })}
                  </>
                </Collapsible>
              }
              {showReportPart && editableUsers.size > 0 && (
                <Collapsible header={messages.requestNewTopic} nested>
                  <>
                    {
                      <QuestionHintBox color={blue}>
                        <HintIcon type="info" color={blue} />
                        <HintText style={{ color: blue }}>
                          <span>{messages.batchAddHint}</span>
                        </HintText>
                      </QuestionHintBox>
                    }

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <Select
                        onChangeValues={(values) => {
                          if (!values.length) setSelectedBatchAddTopic(null);
                          else if (typeof values[0].value === 'string') {
                            setNewTopicName(values[0].value);
                            setRequestingNewTopicModalOpen(true);
                          } else if (values[0].value === -1) {
                            setNewTopicName('');
                            setRequestingNewTopicModalOpen(true);
                          } else
                            setSelectedBatchAddTopic(Number(values[0]?.value));
                        }}
                        letAddChip={true}
                        addPrefix={messages.requestNewTopic}
                        placeholder={messages.addTopic}
                        options={[
                          { value: -1, label: messages.requestNewTopicChoice },
                          ...(
                            (Object.values(
                              props.pdpState.topics || {}
                            ) as Topic[]) || []
                          )
                            .filter(
                              (it) =>
                                it.status !== 'Archived' &&
                                it.status !== 'Disabled'
                            )
                            .map((it: Topic) => {
                              return {
                                value: it.id!,
                                label: it.properties.name!,
                              };
                            }),
                        ]}
                        values={
                          selectedBatchAddTopic
                            ? [
                                {
                                  value: selectedBatchAddTopic,
                                  label:
                                    props.pdpState.topics?.[
                                      selectedBatchAddTopic
                                    ]?.properties?.name || '',
                                },
                              ]
                            : []
                        }
                        label={messages.selectATopic}
                      />
                      <Select
                        options={allRoleOptions}
                        values={selectedBatchAddRoleOption}
                        onChangeValues={(values) => {
                          setSelectedBatchAddRoleOption(values);
                        }}
                        multiChoice={true}
                        placeholder={messages.selectATargetRole}
                        label={messages.selectATargetRole}
                      />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'start' }}>
                      {selectedBatchAddTopic &&
                        (() => {
                          const missingTagOptionKeys = new Set<number>(
                            selectedPdpCompany.properties.topicTagsInPDP
                          );
                          const tagsName = {};
                          props.pdpState.topics![
                            selectedBatchAddTopic
                          ].properties.tags.forEach((tagId) => {
                            const parentId = props.tags[tagId].parentId;
                            if (parentId !== null) {
                              tagsName[props.tags[parentId!].text] =
                                props.tags[tagId].text;
                              missingTagOptionKeys.delete(parentId!);
                            }
                          });
                          return (
                            <HContainer>
                              {(phase?.validTagsToSelect || props.isPDPAdmin
                                ? selectedPdpCompany.properties.topicTagsInPDP
                                : []
                              )
                                // Array.from(missingTagOptionKeys)
                                .map((it) => props.tags[it])
                                .sort(
                                  (a, b) =>
                                    (a.order || Number(a.id)) -
                                    (b.order || Number(b.id))
                                )
                                .map((tag) => {
                                  const currentValue =
                                    selectedBatchAddTopicTags.find((it) => {
                                      return props.tags[it].parentId === tag.id;
                                    });
                                  return (
                                    <div
                                      key={tag.id}
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Select
                                        label={tag.text}
                                        values={
                                          currentValue
                                            ? [
                                                {
                                                  label:
                                                    props.tags[currentValue]
                                                      .text,
                                                  value: currentValue,
                                                },
                                              ]
                                            : []
                                        }
                                        round={true}
                                        inputStyle={{ height: '30px' }}
                                        options={Object.values(props.tags)
                                          .filter(
                                            (it) =>
                                              it.parentId === tag.id &&
                                              !it.deleted
                                          )
                                          .map((it) => ({
                                            label: it.text,
                                            value: it.id,
                                          }))}
                                        onChangeValues={(values) => {
                                          setSelectedBatchAddTopicTag(
                                            Number(tag.id),
                                            Number(values[0]?.value)
                                          );
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                              {Object.entries(tagsName)
                                .sort((a, b) => a[0].localeCompare(b[0]))
                                .map(([key, value]) => {
                                  return (
                                    <div key={key} style={{ color: gray }}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          flex: 1,
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <li>{key}</li>
                                        <div>{value as string}</div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </HContainer>
                          );
                        })()}

                      {!!batchAddUserIds.length && selectedBatchAddTopic && (
                        <Collapsible
                          style={{ flex: 1 }}
                          customBodyStyle={{ padding: '0px 1rem' }}
                          header={
                            batchAddUserIds.length && selectedBatchAddTopic
                              ? messages.batchAddMessage(
                                  batchAddUserIds.length,
                                  props.pdpState.topics![
                                    selectedBatchAddTopic!
                                  ]!.properties.name
                                )
                              : ''
                          }
                        >
                          <ul
                            style={{
                              maxHeight: '50vh',
                              overflow: 'auto',
                              padding: '2px',
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '10px',
                            }}
                          >
                            {batchAddUserIds.map((id) => (
                              <PersonInList
                                key={id}
                                style={{
                                  cursor: 'pointer',
                                  height: '28px',
                                  color: black,
                                  flexShrink: 0,
                                }}
                                onClick={() => {
                                  if (
                                    !dirty ||
                                    confirm(messages.changesNotSaved)
                                  ) {
                                    setSelectedUserId(id);
                                    setSelectedTab('persons');
                                  }
                                }}
                              >
                                {props.users[id].name}
                              </PersonInList>
                            ))}
                          </ul>
                        </Collapsible>
                      )}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'end',
                        gap: '10px',
                      }}
                    >
                      <Button
                        disabled={
                          !batchAddUserIds.length || !selectedBatchAddTopic
                        }
                        loading={addingBatch.has('newTopic')}
                        onClick={() =>
                          performBatchAdd(
                            batchAddUserIds,
                            selectedBatchAddTopic!,
                            'newTopic',
                            'Approved',
                            selectedBatchAddTopicTags
                          )
                        }
                        color={'green'}
                      >
                        {messages.batchAddTo(batchAddUserIds.length)}
                      </Button>
                    </div>
                  </>
                </Collapsible>
              )}
            </Container>
            {selectedTopicToView &&
              topicStats[selectedTopicToView] &&
              (() => {
                const topicStat = topicStats[selectedTopicToView];
                const topicId = selectedTopicToView;
                const topic = props.pdpState.topics?.[topicId];
                if (!topic) return <></>;
                const foundClass = Object.values(
                  props.pdpState.classes || {}
                ).find(
                  (c) =>
                    c.topicId === topicId &&
                    !c.deleted &&
                    c.relatedTermIds.includes(props.term!.id!)
                );
                let crateClassOptions = [] as PDPClass[];
                if (!foundClass) {
                  const now = new Date().getTime();
                  crateClassOptions = Object.values(
                    props.pdpState.classes || {}
                  ).filter(
                    (c) =>
                      c.topicId === topicId &&
                      !c.template &&
                      !c.deleted &&
                      (!c.endDate || c.endDate > now)
                  );
                  crateClassOptions.push({
                    properties: {
                      phaseProps:
                        selectedPdpCompany.properties.classPhaseDefaultProps ||
                        [],
                      allowChooseGroup: 'AllowChange',
                      classGroups: [],
                      classDocumentHomeId: null as any,
                      autoApproveProps: {
                        autoApproveEnabled: false,
                        phaseList: [],
                      },
                    },
                    id: undefined as any,
                    participants: [],
                    relatedTermIds: [],
                    topicId: topicId,
                    template: true,
                  });
                }
                return (
                  <Container style={{ flex: 1 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Button onClick={() => setShowStatsModal(true)}>
                        <Icon type={'pie-chart'} />
                        {messages.stats('')}
                      </Button>
                      <div>
                        {props.isPDPAdmin &&
                          (() => {
                            if (topic.status === 'Archived') {
                              return (
                                <Button
                                  color={'red-outline'}
                                  loading={addingBatch.has('delete' + topicId)}
                                  onClick={() => {
                                    if (confirm(messages.deleteThisTopic))
                                      performBatchDelete(
                                        topicId,
                                        'delete' + topicId
                                      );
                                  }}
                                >
                                  <Icon type="trash" /> {messages.delete}
                                </Button>
                              );
                            } else if (topic.status === 'Proposed') {
                              return (
                                <APopover
                                  arrow
                                  curveBorder
                                  placement="auto-end"
                                  target={
                                    <Button
                                      loading={creatingClass.includes(topicId)}
                                      color="green-outline"
                                    >
                                      {messages.acceptTopic(
                                        topic.properties.name
                                      )}
                                    </Button>
                                  }
                                >
                                  <div>
                                    <h5>
                                      {messages.acceptTopic(
                                        topic.properties.name
                                      )}
                                    </h5>
                                    <table>
                                      <TopicEditor
                                        topic={{
                                          ...topic,
                                          status: 'Exists',
                                          properties: {
                                            ...topic.properties,
                                            name: topic.properties.name.replace(
                                              '*',
                                              ''
                                            ),
                                          },
                                        }}
                                        forApprove={true}
                                        allRoleOptions={allRoleForTopicOptions}
                                        selectTagOptions={tagOptions.reduce(
                                          (current, it) => {
                                            const par = it.parent;
                                            if (!par) return current;
                                            if (!current[par])
                                              current[par] = [];
                                            const newItem = {
                                              ...it,
                                            } as IOption;
                                            delete newItem.disabled;
                                            delete newItem.parent;
                                            current[par!].push(newItem);
                                            return current;
                                          },
                                          {} as {
                                            [key: number]: IOption[];
                                          }
                                        )}
                                        createOrUpdateTopic={props.addNewTopic}
                                        allTags={props.tags}
                                        pdpId={pdpId}
                                        editPDPClass={() => {
                                          /*do nothing*/
                                        }}
                                        createPDPClass={() => {
                                          /*do nothing*/
                                          return Promise.reject();
                                        }}
                                        edit={true}
                                      />
                                    </table>
                                  </div>
                                </APopover>
                              );
                            } else if (foundClass) {
                              return (
                                <Button
                                  color="blue"
                                  onClick={() => {
                                    navigate(`./class/${foundClass!.id}`);
                                  }}
                                >
                                  {messages.viewClass}
                                </Button>
                              );
                            } else
                              return (
                                <Dropdown
                                  curveBorder
                                  width={400}
                                  placement="bottom"
                                  target={
                                    <Button
                                      loading={creatingClass.includes(topicId)}
                                      color="green-outline"
                                    >
                                      {messages.createClass(
                                        topic.properties.name
                                      )}{' '}
                                    </Button>
                                  }
                                >
                                  <Dropdown.Menu
                                    style={{
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                    }}
                                  >
                                    {creatingClass.includes(topicId) ? (
                                      <LoadingCircleIndicator />
                                    ) : (
                                      crateClassOptions.map(
                                        (it, idx: number) => {
                                          if (it.template) {
                                            return (
                                              <Dropdown.MenuItem
                                                key={idx}
                                                // color="green-outline"
                                              >
                                                <span
                                                  onClick={() =>
                                                    createClass(
                                                      topicId,
                                                      it,
                                                      topicStats[topicId]
                                                        .approved
                                                    )
                                                  }
                                                >
                                                  <Icon type="plus" />{' '}
                                                  {messages.createNewClass}{' '}
                                                </span>
                                              </Dropdown.MenuItem>
                                            );
                                          } else {
                                            return (
                                              <Dropdown.MenuItem
                                                key={idx}
                                                // color="blue-outline"
                                              >
                                                <span
                                                  onClick={() =>
                                                    addTermToClass(
                                                      it,
                                                      Number(props.termId),
                                                      topicStats[topicId]
                                                        .approved
                                                    )
                                                  }
                                                >
                                                  <Icon type="link-2" />{' '}
                                                  {messages.useClassSharedWith(
                                                    it.relatedTermIds.map(
                                                      (it) =>
                                                        props.pdpState.terms![
                                                          it
                                                        ].term?.properties
                                                          ?.name ?? ''
                                                    )
                                                  )}
                                                </span>
                                              </Dropdown.MenuItem>
                                            );
                                          }
                                        }
                                      )
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              );
                            /* else if (foundClass) {
                            return (
                              <Button
                                color="blue"
                                onClick={() => {
                                  navigate(`./class/${foundClass!.id}`);
                                }}
                              >
                                {messages.viewClass}
                              </Button>
                            );
                          } else {
                            return (
                              <Button
                                color={'red-outline'}
                                onClick={() => {
                                  createClass(
                                    topicId,
                                    undefined,
                                    topicStats[topicId].approved
                                  );
                                }}
                              >
                                {messages.createClass(
                                  topic.properties.name
                                )}
                              </Button>
                            );
                          }*/
                          })()}
                      </div>
                    </div>
                    <Modal
                      isActive={showStatsModal}
                      onClose={() => setShowStatsModal(false)}
                      title={messages.stats(topic.properties.name)}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          flexGrow: 1,
                        }}
                      >
                        {(() => {
                          const toShowStats = new Set<number>();
                          props.term?.properties.phaseConfig.phases.forEach(
                            (it) => {
                              it.validTagsToSelect?.forEach((it) => {
                                toShowStats.add(it);
                              });
                            }
                          );
                          if (toShowStats.size === 0) {
                            return (
                              <div style={{ margin: 'auto' }}>
                                {messages.notFound}
                              </div>
                            );
                          }
                          const elements = Array.from(toShowStats)
                            .map((it) => props.tags[it])
                            .sort(
                              (a, b) =>
                                (a.order || Number(a.id)) -
                                (b.order || Number(b.id))
                            )
                            .map((tag) => {
                              let found = 0;
                              const total =
                                topicStat.unknown.length +
                                topicStat.approved.length;
                              return (
                                <Card
                                  key={tag.id}
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // maxWidth: '350px',
                                    flex: 1,
                                  }}
                                >
                                  <b>{tag.text}</b>
                                  {tagGroup[tag.id]?.map((t: number) => {
                                    if (props.tags[t].deleted) return <></>;
                                    found += topicStat[t] || 0;
                                    return (
                                      <div
                                        key={t}
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <span
                                          style={{
                                            marginInlineEnd: '5px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {props.tags[t].text}
                                        </span>
                                        <span>
                                          {convertDigitToProperFormat(
                                            topicStat[t] || 0
                                          )}
                                        </span>
                                      </div>
                                    );
                                  })}
                                  {found < total && (
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <span
                                        style={{
                                          marginInlineEnd: '5px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {messages.noSelected}
                                      </span>
                                      <span>
                                        {convertDigitToProperFormat(
                                          total - found
                                        )}
                                      </span>
                                    </div>
                                  )}
                                  <Collapsible
                                    header={messages.changeAllTo(tag.text)}
                                  >
                                    {(() => {
                                      const currentValue =
                                        selectedBatchChangeTopicTags[
                                          topic.id!
                                        ]?.[tag.id];

                                      const options = Object.values(props.tags)
                                        .filter(
                                          (it) =>
                                            it.parentId === tag.id &&
                                            !it.deleted
                                        )
                                        .map((it) => ({
                                          label: it.text,
                                          value: it.id,
                                        }));
                                      return (
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            gap: '10px',
                                          }}
                                        >
                                          <Select
                                            allowRemove={false}
                                            values={
                                              currentValue
                                                ? [
                                                    {
                                                      label:
                                                        props.tags[currentValue]
                                                          .text,
                                                      value: currentValue,
                                                    },
                                                  ]
                                                : []
                                            }
                                            inputStyle={{
                                              height: '30px',
                                            }}
                                            options={options}
                                            onChangeValues={(values) => {
                                              const newS = cloneDeep(
                                                selectedBatchChangeTopicTags
                                              );
                                              if (!newS[topic!.id!])
                                                newS[topic!.id!] = {};
                                              newS[topic!.id!][tag.id] = Number(
                                                values[0]?.value
                                              );
                                              setSelectedBatchChangeTopicTags(
                                                newS
                                              );
                                            }}
                                          />
                                          <Button
                                            color={'blue'}
                                            disabled={!currentValue}
                                            loading={addingBatch.has(
                                              'updateTag' + tag.id
                                            )}
                                            onClick={() => {
                                              performBatchAdd(
                                                topicStat.approved,
                                                topic!.id!,
                                                'updateTag' + tag.id,
                                                'Approved',
                                                undefined,
                                                options.map((it) => {
                                                  return Number(it.value);
                                                }),
                                                [currentValue]
                                              );
                                            }}
                                          >
                                            {messages.set}
                                          </Button>
                                        </div>
                                      );
                                    })()}
                                  </Collapsible>
                                </Card>
                              );
                            });
                          if (elements.length > 0)
                            elements.push(
                              <div
                                style={{
                                  width: '100%',
                                  flexGrow: 1,
                                  padding: '0px 15px',
                                  fontSize: '10px',
                                }}
                              >
                                {messages.rejectedTopicsAreNotIncluded}
                              </div>
                            );
                          return elements;
                        })()}
                      </div>
                    </Modal>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // overflow: 'auto',
                        height: 'calc(100% - 30px)',
                      }}
                    >
                      <div
                        style={{
                          // maxWidth: '350px',
                          minWidth: '300px',
                          // borderLeft: `1px dotted ${gray}`,
                        }}
                      >
                        {[
                          'unknown',
                          'approved',
                          'rejected',
                          'previousRejected',
                          // 'mandatoryUsers',
                          // 'optionalUsers',
                          'notRelatedUsers',
                        ].map((type) => {
                          return (
                            topicStat[type].length > 0 && (
                              <Collapsible
                                customCollapsibleHeaderStyle={{
                                  backgroundColor:
                                    type === 'unknown'
                                      ? lightYellowSolid
                                      : undefined,
                                  zIndex: 96,
                                }}
                                customHeaderStyle={{
                                  width: '100%',
                                  backgroundColor:
                                    type === 'unknown'
                                      ? lightYellowSolid
                                      : undefined,
                                }}
                                defaultOpen={
                                  type === 'unknown' || type === 'approved'
                                }
                                header={
                                  <ApproveGroup>
                                    <b style={{ color: statColor[type] }}>
                                      {messages[type]}:
                                    </b>
                                    {(type === 'unknown' ||
                                      type === 'mandatoryUsers' ||
                                      type === 'optionalUsers') &&
                                      topicStat[type].some((uid) =>
                                        editableUsers.has(uid)
                                      ) && (
                                        <span
                                          style={{
                                            display: 'flex',
                                            gap: '10px',
                                          }}
                                        >
                                          <Button
                                            color="green"
                                            style={{ height: '25px' }}
                                            loading={addingBatch.has(
                                              'all' + topicId
                                            )}
                                            onClick={() => {
                                              performBatchAdd(
                                                topicStat[type],
                                                Number(topicId),
                                                'all' + topicId
                                              );
                                            }}
                                          >
                                            {messages.approveAll}
                                          </Button>
                                          {type === 'unknown' && (
                                            <Button
                                              color="red"
                                              style={{ height: '25px' }}
                                              loading={addingBatch.has(
                                                'all' + topicId + 'reject'
                                              )}
                                              onClick={() => {
                                                performBatchAdd(
                                                  topicStat[type],
                                                  Number(topicId),
                                                  'all' + topicId + 'reject',
                                                  'Rejected'
                                                );
                                              }}
                                            >
                                              {messages.rejectAll}
                                            </Button>
                                          )}
                                        </span>
                                      )}
                                    {(() => {
                                      if (
                                        type === 'approved' &&
                                        props.isPDPAdmin &&
                                        foundClass &&
                                        !foundClass.template
                                      ) {
                                        const notInClass = topicStat[
                                          type
                                        ].filter(
                                          (userId) =>
                                            !foundClass!.participants[userId]
                                        );
                                        if (notInClass.length > 0)
                                          return (
                                            <span
                                              style={{
                                                display: 'flex',
                                                gap: '10px',
                                              }}
                                            >
                                              <Button
                                                color="green"
                                                style={{ height: '25px' }}
                                                loading={addingBatch.has(
                                                  'class' + topicId
                                                )}
                                                onClick={() => {
                                                  addAllUsersToClass(
                                                    notInClass,
                                                    foundClass!
                                                  );
                                                }}
                                              >
                                                {messages.addAllUsersToClass}
                                              </Button>
                                            </span>
                                          );
                                      }
                                      return <></>;
                                    })()}
                                    {/*{phase && (
                                          <span>
                                            <Button
                                              color="red"
                                              style={{ height: '25px' }}
                                              loading={addingBatch.has(
                                                'all' + topicStats[0] + 'reject'
                                              )}
                                              onClick={() => {
                                                performBatchAdd(
                                                  topicStats[1][type],
                                                  Number(topicStats[0]),
                                                  'all' +
                                                    topicStats[0] +
                                                    'reject',
                                                  'Rejected'
                                                );
                                              }}
                                            >
                                              {messages.rejectAll}
                                            </Button>
                                          </span>
                                        )}*/}
                                  </ApproveGroup>
                                }
                                customBodyStyle={{
                                  backgroundColor:
                                    type === 'unknown'
                                      ? lightYellowSolid
                                      : undefined,
                                }}
                              >
                                <>
                                  <div
                                    style={{
                                      overflow: 'hidden',
                                      // maxHeight:
                                      //   Math.max(
                                      //     topicStat[type].length,
                                      //     10
                                      //   ) * 30,
                                      height:
                                        topicStat[type].length > 10
                                          ? 300
                                          : topicStat[type].length < 3
                                            ? 90
                                            : 30 * topicStat[type].length,
                                    }}
                                  >
                                    {
                                      <AutoSizer style={{ width: '100%' }}>
                                        {({ height }: { height: number }) => {
                                          return (
                                            <List
                                              width="100%"
                                              height={height} // space from bottom
                                              itemData={{
                                                items: topicStat[type],
                                                foundClass,
                                                topicStat,
                                                topicId,
                                              }}
                                              itemSize={30}
                                              itemCount={topicStat[type].length}
                                              direction="rtl"
                                              style={{
                                                // borderRadius: '15px',
                                                // border: `1px solid ${lightGray}`,
                                                overflow: 'overlay',
                                              }}
                                            >
                                              {getPersonInApprovedList}
                                            </List>
                                          );
                                        }}
                                      </AutoSizer>
                                    }
                                  </div>

                                  {/*{topicStat[type].map(
                                          (userId: number) =>
                                            getApproveGroupItem(
                                              userId,
                                              topicStat,
                                              foundClass as any
                                            )
                                        )}*/}
                                </>
                              </Collapsible>
                            )
                          );
                        })}
                      </div>

                      {!!props.pdpState.topics![topic.id!].properties
                        .mandatoryForRoles?.length &&
                        props.isPDPAdmin &&
                        getAllUserStats(
                          topic,
                          messages.mandatoryUsers,
                          topicStat.mandatoryRoleStats,
                          props.pdpState.topics![topic.id!].properties
                            .mandatoryForRoles
                        )}
                      {(props.pdpState.topics![topic.id!].properties
                        .relatedToRoles?.length ?? 0) >
                        (props.pdpState.topics![topic.id!].properties
                          .mandatoryForRoles?.length ?? 0) &&
                        props.isPDPAdmin &&
                        getAllUserStats(
                          topic,
                          messages.optionalUsers,
                          topicStat.optionalRoleStats,
                          props.pdpState.topics![
                            topic.id!
                          ].properties.relatedToRoles.filter((it) => {
                            return !props.pdpState.topics![
                              topic.id!
                            ].properties.mandatoryForRoles?.includes(it);
                          })
                        )}
                    </div>
                  </Container>
                );
              })()}
          </div>
        )}
      </TermsWrapper>
      <AddModal
        onClose={() => setRequestingNewTopicModalOpen(false)}
        active={requestingNewTopicModalOpen}
        value={newTopicName}
        onChange={(e) => {
          setNewTopicName(e.target.value);
        }}
        onAdd={() => {
          requestTopic(newTopicName);
        }}
        loading={requestingTopic}
      />
    </div>
  );
};
const mapStateToProps: MapStateToProps<StateToProps, IOwnProps, RootState> = (
  state,
  ownProps
) => {
  const pdpId = Number(ownProps.pdpId);
  const providerIds = Object.values(state.providers.map).reduce(
    (current: number[], it) => {
      if (it.data?.managingCompanyId === Number(ownProps.companyId))
        current.push(it.data.id);
      return current;
    },
    [] as number[]
  );
  let tags = {};
  const toLoadTags = [] as number[];
  providerIds.forEach((id: number) => {
    if (!state.providers.tags[id]?.status) toLoadTags.push(id);
    tags = {
      ...tags,
      ...state.providers.tags[id]?.data,
    };
  });
  const companyView = state.companies.data[Number(ownProps.companyId)];
  const company = companyView as ICompany;
  const users = state.users.map;
  const thisUser = state.thisUser as IThisUser;

  const pdpState = state.pdp.pdpMap[pdpId!];
  const selectedCompanyPdp = company.pdpPanels.find(
    (companyPdp) => companyPdp.id === pdpId
  )!;
  const term = pdpState?.terms?.[Number(ownProps.termId)]?.term ?? undefined;
  const thisUserView = state.thisUser;
  const member = company.members[Number(thisUser.userId)] || undefined;

  const isPDPAdmin = Boolean(
    isCompanyOwnerOrSupport(thisUserView, companyView) ||
      (selectedCompanyPdp.managerRoleId &&
        member.roles[selectedCompanyPdp.managerRoleId])
  );
  return {
    thisUser,
    users,
    term,
    company,
    tags,
    pdpState,
    isPDPAdmin,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    getAllTopics: (pdpId: number) => appDispatch(getAllTopics({ pdpId })),
    addNewTopic: (topic: Topic) => appDispatch(createOrUpdateTopic({ topic })),
    getMyTerms: (pdpId: number) => appDispatch(getMyTerms({ pdpId })),
    getMyManagingTerms: (pdpId: number) =>
      appDispatch(getMyManagingTerms({ pdpId })),
    getMyPDPProgram: (termId: number, pdpId: number) =>
      appDispatch(getMyPDPInTerm({ termId, pdpId })),
    getMyManagingPDPProgram: (termId: number, pdpId: number) =>
      appDispatch(getMyManagingPDPInTerm({ termId, pdpId })),
    createOrUpdatePDPProgram: (program: PDPProgram, pdpId: number) =>
      appDispatch(createOrUpdatePDPProgram({ program, pdpId })),
    deletePDPProgram: (program: PDPProgram, pdpId: number) =>
      appDispatch(deletePDPProgram({ program, pdpId })),
    createOrUpdateBatchPDPProgram: (programs: PDPProgram[], pdpId: number) =>
      appDispatch(createOrUpdateBatchPDPProgram({ programs, pdpId })),
    queryClasses: (
      pdpId: number,
      startDate?: number,
      endDate?: number,
      isTemplate?: boolean
    ) =>
      appDispatch(
        queryClasses({
          pdpId,
          startDate,
          endDate,
          isTemplate,
        })
      ),
    createOrUpdateClass: (pdpClass: PDPClass, pdpId: number) =>
      appDispatch(createOrUpdateClass({ clazz: pdpClass, pdpId })),
    addParticipantsToClass: (
      pdpId: number,
      clazzId: number,
      userIds: number[]
    ) =>
      appDispatch(
        addParticipants({ pdpId, clazzId, userIds, isCorrective: false })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PDPPersonManager);
